module.exports = __webpack_public_path__ + "static/media/submissionFailed.ca66186b.svg";